import { motion } from 'framer-motion';

export default function HowItWorks() {
    const steps = [
        {
            num: "01",
            title: "Set Your Goals",
            desc: "Choose your target role, industry, and difficulty level to customize your practice."
        },
        {
            num: "02",
            title: "Practice with AI",
            desc: "Answer realistic interview questions in real-time with our lifelike AI interviewer."
        },
        {
            num: "03",
            title: "Get Feedback",
            desc: "Receive comprehensive analysis on your performance and actionable tips to improve."
        }
    ];

    return (
        <section id="how-it-works" className="py-32 relative bg-black">
            {/* Background glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-blue-500/[0.05] rounded-full blur-[120px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-24"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">How it Works</h2>
                    <p className="text-zinc-400 max-w-2xl mx-auto text-lg">
                        Start improving your interview skills in three simple steps.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
                    {/* Connector Line (Desktop) */}
                    <div className="hidden md:block absolute top-12 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white/[0.1] to-transparent" />

                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.2 }}
                            className="relative text-center"
                        >
                            <div className="w-24 h-24 mx-auto rounded-full bg-[#050505] border border-white/[0.1] flex items-center justify-center mb-8 relative z-10 shadow-[0_0_30px_rgba(0,0,0,0.5)]">
                                <span className="text-3xl font-bold text-gradient-blue">{step.num}</span>
                            </div>
                            <h3 className="text-2xl font-bold mb-4">{step.title}</h3>
                            <p className="text-zinc-400 leading-relaxed px-6">
                                {step.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
